/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loading-end': {
    width: 11,
    height: 9,
    viewBox: '0 0 11 9',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M2.005 6.023H4.44v2.435H2.005zM4.44 6.023h2.435v2.435H4.44zM4.44 3.588h2.435v2.435H4.44zM2.005 3.588H4.44v2.435H2.005zM4.44 1.152h2.435v2.435H4.44z"/><path pid="1" d="M6.872 6.023h2.435v2.435H6.872zM6.872 3.588h2.435v2.435H6.872zM.826 8.478h9.73"/></g>'
  }
})
